import { C } from '../../theme.js';
import { Alert, Code, Eyebrow, FieldLabel } from '../../components/Primitives.jsx';
import { MultiColsDropdown } from './MultiColsDropdown.jsx';
import { hasUpstreamSplit } from '../../data.js';
import { DecimalPlacesField } from '../shared/DecimalPlacesField.jsx';
import { OutputColumnNamesField } from '../shared/OutputColumnNamesField.jsx';

/**
 * MinMaxScalingInspector
 * Formula: x_scaled = t_min + ((x - x_min) / (x_max - x_min)) * (t_max - t_min)
 * The user picks a range preset: [0, 1] (default) or [-1, +1].
 */
export function MinMaxScalingInspector({ step, onChange, pipeline }) {
  const c = step.config || {};
  const sel = Array.isArray(c.columns) ? c.columns : (c.column ? [c.column] : []);
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  const currentRange = c.range || "0,1";
  const splitReady = pipeline ? hasUpstreamSplit(pipeline.steps, step.id) : true;

  return (
    <div>
      <Eyebrow>Min-Max scaling</Eyebrow>
      <div style={{ color: C.fg4, fontSize: '.78rem', margin: '4px 0 10px', lineHeight: 1.5 }}>
        Rescale numerical features to a target range preset ([0, 1] or [-1, +1]).
        Each selected column is kept; a new <Code>{'<col>_method_scaled'}</Code> column is added.
      </div>
      {!splitReady && (
        <Alert kind="warn" style={{ marginBottom: 10 }}>
          No Train / Test Split step found upstream — this will fit using all rows. If the result feeds a model, add a Train / Test Split step first to avoid data leakage.
        </Alert>
      )}
      <MultiColsDropdown selected={sel} onChange={(v) => u({ columns: v, column: v[0] || null })} numeric />
      <div style={{ marginTop: 10 }}>
        <FieldLabel hint="Target scaling range">Range Preset</FieldLabel>
        <select
          value={currentRange}
          onChange={(e) => u({ range: e.target.value })}
          style={{
            width: '100%',
            background: C.input || '#1e2028',
            color: C.fg1 || '#f3f4f6',
            border: `1px solid ${C.border || '#374151'}`,
            borderRadius: 4,
            padding: '6px 8px',
            fontSize: '0.82rem',
            marginTop: 4,
            outline: 'none',
            cursor: 'pointer'
          }}
        >
          <option value="0,1">[0, 1] Range</option>
          <option value="-1,1">[-1, +1] Range</option>
        </select>
      </div>
      <OutputColumnNamesField
        columns={sel}
        value={c.output_columns}
        onChange={(v) => u({ output_columns: v })}
        legacyValue={c.output_column}
        autoName={(col) => `${col}_min_max_scaled`}
      />
      <DecimalPlacesField value={c.output_decimals} onChange={(v) => u({ output_decimals: v })} />
    </div>
  );
}
